// DropZone.js
import React, { useCallback, useState, useRef, useEffect } from 'react';
import { useDropzone } from 'react-dropzone';

function DropZone({ onFilesAdded, label, allowFolders = false }) {
  const [selectedFiles, setSelectedFiles] = useState([]);

  const onDrop = useCallback(
    (acceptedFiles) => {
      const audioFiles = acceptedFiles.filter((file) => {
        const lowerName = file.name.toLowerCase();
        return lowerName.endsWith('.wav') || lowerName.endsWith('.mp3');
      });
      onFilesAdded(audioFiles);
      if (audioFiles.length > 0) {
        const fileNames = audioFiles.map((f) => f.name);
        setSelectedFiles((prev) => [...prev, ...fileNames]);
      }
    },
    [onFilesAdded]
  );

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: { 'audio/wav': ['.wav'], 'audio/mpeg': ['.mp3'] },
  });

  // Conditionals for folder selection
  const folderAttrs = allowFolders
    ? { webkitdirectory: '', mozdirectory: '', directory: '' }
    : {};

  return (
    <div
      {...getRootProps()}
      style={{
        border: '2px dashed #999',
        borderRadius: '8px',
        padding: '1rem',
        textAlign: 'center',
        cursor: 'pointer',
        marginBottom: '1rem',
      }}
      className={isDragActive ? 'dropzone dropzone--active' : 'dropzone'}
    >
      {/* Merge folder attrs with standard props */}
      <input
        type="file"
        multiple
        {...folderAttrs}
        {...getInputProps()}
      />
      <p>{label}</p>
      <p>
        {allowFolders
          ? 'Drag & drop folder or click to select folder...'
          : 'Drag & drop or click to select (.wav or .mp3)'}
      </p>

      {selectedFiles.length > 0 && (
        <div style={{ marginTop: '1rem', textAlign: 'left' }}>
          <strong>Selected Files:</strong>
          <ul style={{ listStyleType: 'disc', marginLeft: '20px' }}>
            {selectedFiles.map((name, idx) => (
              <li key={idx}>{name}</li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}

export default DropZone;
